export default __webpack_public_path__ + "static/media/payment@2x.89eccda8.png";